export default __webpack_public_path__ + "static/media/sands-of-time.a190c707.mp4";